export default __webpack_public_path__ + "static/media/resume-jam.1bc9ed10.png";